import * as React from 'react';

export default () => (
    <svg
        width="58px"
        height="58px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
    >
        <circle cx="50" cy="50" r="38.352" fill="none" stroke="#368cd7" strokeWidth="25">
            <animate attributeName="r" calcMode="spline" values="0;40" keyTimes="0;1" dur="1.5" keySplines="0 0.2 0.8 1" begin="-0.75s" repeatCount="indefinite"/>
            <animate attributeName="opacity" calcMode="spline" values="1;0" keyTimes="0;1" dur="1.5" keySplines="0.2 0 0.8 1" begin="-0.75s" repeatCount="indefinite"/>
        </circle>
        <circle cx="50" cy="50" r="21.5384" fill="none" stroke="#7cbefa" strokeWidth="25">
            <animate attributeName="r" calcMode="spline" values="0;40" keyTimes="0;1" dur="1.5" keySplines="0 0.2 0.8 1" begin="0s" repeatCount="indefinite"/>
            <animate attributeName="opacity" calcMode="spline" values="1;0" keyTimes="0;1" dur="1.5" keySplines="0.2 0 0.8 1" begin="0s" repeatCount="indefinite"/>
        </circle>
    </svg>
);



// WEBPACK FOOTER //
// ./src/Assets/images/svg/ripple.tsx